import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getPublishedBlogs } from '../../services/blogService';
import './BlogList.css';

const CATEGORIES = ['All', 'Bridal', 'Makeup Tips', 'Skincare', 'Tutorials', 'Courses', 'Behind the Scenes'];

const fmtDate = (ts) => {
  if (!ts) return '';
  const d = ts.toDate ? ts.toDate() : new Date(ts);
  return d.toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' });
};

export default function BlogList() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeCategory, setActiveCategory] = useState('All');

  useEffect(() => {
    getPublishedBlogs().then(d => { setBlogs(d); setLoading(false); });
  }, []);

  const filtered = activeCategory === 'All' ? blogs : blogs.filter(b => b.category === activeCategory);

  return (
    <div className="blog-page">
      <div className="blog-hero fade-in">
        <h1>Our Blog</h1>
        <p>Makeup tips, bridal guides, skincare secrets & behind-the-scenes stories</p>
      </div>

      <div className="blog-filters">
        {CATEGORIES.map(cat => (
          <button
            key={cat}
            className={`blog-filter-btn${activeCategory === cat ? ' active' : ''}`}
            onClick={() => setActiveCategory(cat)}
          >
            {cat}
          </button>
        ))}
      </div>

      <div className="blog-grid">
        {loading && <div className="blog-empty"><p>Loading posts…</p></div>}
        {!loading && filtered.length === 0 && (
          <div className="blog-empty"><p>No posts in this category yet.</p></div>
        )}
        {filtered.map(blog => (
          <Link key={blog.id} to={`/blog/${blog.slug}`} className="blog-card slide-up">
            {blog.coverImage
              ? <img src={blog.coverImage} alt={blog.title} className="blog-card-cover" />
              : <div className="blog-card-cover-placeholder">✨</div>
            }
            <div className="blog-card-body">
              <div className="blog-card-meta">
                {blog.category && <span className="blog-category">{blog.category}</span>}
                <span className="blog-date">{fmtDate(blog.publishedAt)}</span>
              </div>
              <h2 className="blog-card-title">{blog.title}</h2>
              {blog.excerpt && <p className="blog-card-excerpt">{blog.excerpt}</p>}
              <span className="blog-read-more">Read more →</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
